const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");

const DashBoard = r => require.ensure([], () => r(require('./views/Dashboard.vue')))

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/dashboard",
      component: DashBoard
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
